import React from 'react';

export default function CustomSlider({ value, onChange, min = 0, max = 1, step = 0.01, disabled = false }) {
  const percent = ((value - min) / (max - min)) * 100;
  return (
    <div style={{ position: 'relative', width: '100%', height: 16, margin: '8px 0' }}>
      {/* 背景轨道 */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          height: 6,
          width: '100%',
          background: '#e5e7eb',
          borderRadius: 3,
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      />
      {/* 填充进度条 */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          height: 6,
          width: percent + '%',
          background: '#3b82f6',
          borderRadius: 3,
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          transition: 'width 0.1s',
          zIndex: 2,
        }}
      />
      {/* 滑块圆点 */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: `calc(${percent}% - 8px)`,
          transform: 'translateY(-50%)',
          zIndex: 2,
          pointerEvents: 'none',
        }}
      >
        <div style={{
          width: 16,
          height: 16,
          background: '#fff',
          border: '2px solid #3b82f6',
          borderRadius: '50%',
          boxShadow: '0 1px 4px rgba(59,130,246,0.15)',
          transition: 'border-color 0.1s',
          opacity: disabled ? 0.5 : 1,
        }} />
      </div>
      {/* 透明 input 负责交互 */}
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => onChange(parseFloat(e.target.value))}
        disabled={disabled}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
          zIndex: 3,
        }}
      />
    </div>
  );
} 